import React from 'react';
import { Fade } from "react-awesome-reveal";
import check from '../../images/icon/check.svg'
import error from '../../images/icon/erorr.svg'
import logo from '../../images/logo/Logo-certa-white.png'
import star from '../../images/icon/star.svg'

const FeaturesSection = (props) => {

    return (
      <section className="feature">
        <div className="feature-wrapper sec-bg sec-bg--2 pt-130 pb-130">
          <div className="container">
            <div className="feature_inner">
              <div className="sec-title--two text-center mb-60">
                <Fade
                  direction="down"
                  triggerOnce={"false"}
                  duration={1000}
                  delay={9}
                >
                  <div>
                    <div
                      className="sub-title wow fadeInDown"
                      data-wow-duration="600ms"
                    >
                      <img src={star} alt="" />
                      Por que somos diferentes
                    </div>
                  </div>
                </Fade>
                <Fade
                  direction="up"
                  triggerOnce={"false"}
                  duration={1200}
                  delay={9}
                >
                  <div>
                    <h2
                      className="title wow fadeInDown"
                      data-wow-delay="150ms"
                      data-wow-duration="600ms"
                    >
                      Veja como nos diferenciamos dos<br></br>provedores
                      internacionais
                    </h2>
                  </div>
                </Fade>
              </div>
              <table className="feature-table">
                <thead>
                  <tr>
                    <th>Características</th>
                    <th>
                      <img src={logo} alt="" />
                    </th>
                    <th>Provedores<br></br>Internacionais</th>
                  </tr>
                </thead>
                <tbody className="table-body">
                  <tr>
                    <td>Servidores no Brasil com latência ultra baixa</td>
                    <td>
                      <img src={check} alt="" />
                    </td>
                    <td>
                      <img src={error} alt="" />
                    </td>
                  </tr>
                  <tr>
                    <td>Suporte técnico 24/7 em português</td>
                    <td>
                      <img src={check} alt="" />
                    </td>
                    <td>
                      <img src={error} alt="" />
                    </td>
                  </tr>
                  <tr>
                    <td>Preços em Real sem variação cambial</td>
                    <td>
                      <img src={check} alt="" />
                    </td>
                    <td>
                      <img src={error} alt="" />
                    </td>
                  </tr>
                  <tr>
                    <td>Compliance com LGPD</td>
                    <td>
                      <img src={check} alt="" />
                    </td>
                    <td>
                      <img src={check} alt="" />
                    </td>
                  </tr>
                  <tr>
                    <td>Equipe local para visitas técnicas</td>
                    <td>
                      <img src={check} alt="" />
                    </td>
                    <td>
                      <img src={error} alt="" />
                    </td>
                  </tr>
                  <tr>
                    <td>Migração sem downtime com acompanhamento</td>
                    <td>
                      <img src={check} alt="" />
                    </td>
                    <td>
                      <img src={error} alt="" />
                    </td>
                  </tr>
                  <tr>
                    <td>Consultoria personalizada por segmento</td>
                    <td>
                      <img src={check} alt="" />
                    </td>
                    <td>
                      <img src={error} alt="" />
                    </td>
                  </tr>
                  <tr>
                    <td>Integração com ERPs e CRMs brasileiros</td>
                    <td>
                      <img src={check} alt="" />
                    </td>
                    <td>
                      <img src={error} alt="" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    );
}

export default FeaturesSection;